var exports = {
  "h": "asideHeading__JZapZO",
};

module.exports = exports;
